import {
  fetchVehicleWiseCollection,
  fetchCollectionSummary,
  fetchDayWiseCollection,
  markCollection,
  markEditCollection,
  uploadBulkEditGCSheets,
} from "../../services/collectionService";
import {
  dayWiseCollectionFetched,
  collectionSummaryFetched,
  vehicleWiseCollectionFetched,
  grossContributionUploadSheet,
  grossContributionUploadSheetFailure,
} from "../actions/collectionAction";
import { hideLoading } from "../../shared/widgets/bar-loader/src";
import { fetchDataSyncStatus } from "../../services/citiesService";
import { updateRefreshUpliftStatus } from "../actions/contractedVehicleAction";
import { createAllActionCreators } from "./actionCreatorUtil";

const collectionctionCreators = {
  vehicleWiseCollectionListAction: {
    service: fetchVehicleWiseCollection,
    action: vehicleWiseCollectionFetched,
  },
  dayWiseCollectionListAction: {
    service: fetchDayWiseCollection,
    action: dayWiseCollectionFetched,
  },
  collectionSummaryAction: {
    service: fetchCollectionSummary,
    responseFn: async (response, params) => {
      const { dispatch, loaderType } = params;
      dispatch(collectionSummaryFetched(response));
      dispatch(hideLoading(loaderType));
      const dataSyncStatusResponse = await fetchDataSyncStatus();
      dispatch(
        updateRefreshUpliftStatus(
          dataSyncStatusResponse?.success ? dataSyncStatusResponse.success : "",
        ),
      );
    },
  },
  markLiveNoLiveAction: {
    service: markCollection,
    responseNotification: {
      status: true,
      only: true,
    },
    responseNotificationMessage: (response, params) => (params.markOption
      ? `Marked ${params.markOption} Successfully`
      : "Something went wrong"),
  },
  markEditContractAction: {
    service: markEditCollection,
    responseNotification: {
      status: false,
      only: true,
    },
    responseNotificationMessage: () => "Marked Changes Successfully",
  },
  grossContributionUploadSheetAction: {
    service: uploadBulkEditGCSheets,
    action: grossContributionUploadSheet,
    responseNotification: {
      status: true,
    },
    upload: {
      status: true,
      notificationMessage: "Gross Contribution Edit Failed",
      errorAction: grossContributionUploadSheetFailure,
      errorActionMessage: (err) => (err.error
        ? `${err.message}: ${JSON.stringify(err.error)}`
        : err.message || "Something went wrong"),
    },
  },
};

export const {
  vehicleWiseCollectionListAction,
  dayWiseCollectionListAction,
  collectionSummaryAction,
  markLiveNoLiveAction,
  markEditContractAction,
  grossContributionUploadSheetAction,
} = createAllActionCreators(collectionctionCreators);
